module.exports = __webpack_public_path__ + "img/mcu.9d7db389.jpg";